/* ioc-home.js · homepage behaviour: flavor chips + sort on the lineup rail, PACK-CARD size switch and action-bar
   mirroring, plan rail start position, tap-to-play video, peek ducks, duck picks, pause-motion, account menu.
   Cart is native Shopify (Horizon product-form + cart drawer). Loaded on every page (layout/theme.liquid), so every
   block below keys off markup that only exists where it is needed. */
(function () {
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var isPhone = function () { return !window.matchMedia || window.matchMedia("(max-width: 899px)").matches; };

  function init() {
    // ---- lineup (B-Home): chips filter the flavor RAIL; the sort select is desktop only ----
    var lineupRail = document.getElementById("iocFlavorRail");
    var track = lineupRail ? lineupRail.querySelector(".ioc-rail__track") : null;
    var chips = lineupRail ? $$(".lineup [data-filter]") : [];
    var sorter = document.getElementById("iocSorter");
    var empty = document.getElementById("iocLineupEmpty");
    function apply() {
      if (!track) return;
      var on = document.querySelector(".lineup [data-filter].is-on");
      var tag = on ? on.getAttribute("data-filter") : "all";
      var mode = sorter ? sorter.value : "best";
      var items = $$(".flavor-li:not([data-end])", track);
      var end = track.querySelector("[data-end]");
      var shown = 0;
      items.forEach(function (li) {
        var tags = (li.getAttribute("data-tags") || "").split(/\s+/);
        var ok = tag === "all" || tags.indexOf(tag) !== -1;
        li.hidden = !ok;
        if (ok) shown++;
      });
      items.sort(function (a, b) {
        var pa = Number(a.dataset.price), pb = Number(b.dataset.price);
        var ra = Number(a.dataset.rank), rb = Number(b.dataset.rank);
        if (mode === "low") return pa - pb;
        if (mode === "high") return pb - pa;
        if (mode === "az") return (a.dataset.name || "").localeCompare(b.dataset.name || "");
        return ra - rb;
      });
      items.forEach(function (li) { track.insertBefore(li, end); });
      if (empty) empty.hidden = shown > 0;
      // the rail's counter / dots count every card; while a filter is on they would lie, so they step aside
      var ui = lineupRail.querySelector(".ioc-rail__ui");
      if (ui) ui.style.visibility = tag === "all" ? "" : "hidden";
      track.scrollTo({ left: 0, behavior: "instant" });
    }
    chips.forEach(function (ch) {
      ch.addEventListener("click", function () {
        chips.forEach(function (x) { x.classList.remove("is-on"); x.setAttribute("aria-pressed", "false"); });
        ch.classList.add("is-on");
        ch.setAttribute("aria-pressed", "true");
        apply();
      });
    });
    if (sorter) sorter.addEventListener("change", apply);

    // ---- PACK-CARD (sections/ioc-bundles): 6 | 12 keeps the card, its sheet and the action bar in step ----
    function barLabel() { return document.querySelector("[data-ioc-abar] [data-ioc-abar-label]"); }
    function syncPack(card) {
      var b = !!card.querySelector("[data-packcard-size][value='b']:checked");
      card.classList.toggle("is-b", b);
      var next = card.getAttribute(b ? "data-bar-b" : "data-bar-a");
      var prev = card.getAttribute("data-ioc-abar-label");
      if (next && next !== prev) {
        card.setAttribute("data-ioc-abar-label", next);
        // the bar only re-reads a card when the card it mirrors changes; if it is showing this one, update it now
        var bl = barLabel();
        if (bl && bl.textContent.trim() === prev) bl.textContent = next;
      }
      var pane = card.querySelector(".packcard__pane[data-bsize='" + (b ? "b" : "a") + "'] button[name='add']");
      $$("[data-packcard-add='" + card.id + "'] [data-packcard-add-label]").forEach(function (el) {
        if (pane) el.textContent = pane.textContent.trim();
      });
    }
    $$("[data-packcard]").forEach(syncPack);
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (t && t.matches && t.matches("[data-packcard-size]")) { var c = t.closest("[data-packcard]"); if (c) syncPack(c); }
    });
    // "What's in it" sheet footer: add the size chosen on the card
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-packcard-add]");
      if (!btn) return;
      var card = document.getElementById(btn.getAttribute("data-packcard-add"));
      if (!card) return;
      var add = $$(".packcard__pane button[name='add']", card).filter(function (x) { return x.getClientRects().length && !x.disabled; })[0];
      if (add) setTimeout(function () { add.click(); }, 60);
    });

    // ---- action-bar card mode inside a swipe rail: only the card actually in view drives the bar ----
    // (ioc-ui.js picks the [data-ioc-abar-card] nearest the vertical centre; in a sideways rail every card shares
    //  one centre, so the attribute is handed to the card nearest the rail's visible middle.)
    function railCards(t) { return $$("[data-bar-card]", t); }
    function handOff(t) {
      var cards = railCards(t);
      if (!cards.length) return;
      if (!isPhone()) { cards.forEach(function (c) { c.setAttribute("data-ioc-abar-card", ""); }); return; }
      var r = t.getBoundingClientRect(), mid = r.left + r.width / 2, best = null, bestD = Infinity;
      cards.forEach(function (c) {
        var cr = c.getBoundingClientRect();
        var d = Math.abs(cr.left + cr.width / 2 - mid);
        if (d < bestD) { bestD = d; best = c; }
      });
      cards.forEach(function (c) { if (c === best) c.setAttribute("data-ioc-abar-card", ""); else c.removeAttribute("data-ioc-abar-card"); });
      // ioc-ui.js re-reads the cards on page scroll only; a sideways swipe needs a nudge so the bar follows at once
      if (t.__iocBarBest !== best) { t.__iocBarBest = best; document.dispatchEvent(new Event("scroll")); }
    }
    $$(".ioc-rail__track").forEach(function (t) {
      var cards = $$("[data-ioc-abar-card]", t);
      if (!cards.length) return;
      cards.forEach(function (c) { c.setAttribute("data-bar-card", ""); });
      var tick = null;
      var run = function () { tick = null; handOff(t); };
      t.addEventListener("scroll", function () { if (!tick) tick = requestAnimationFrame(run); }, { passive: true });
      window.addEventListener("resize", function () { if (!tick) tick = requestAnimationFrame(run); });
      handOff(t);
    });

    // ---- plans rail: the 12 is scrolled into view on load (focused, never pre-selected) ----
    var plans = document.getElementById("iocPlansRail");
    if (plans && isPhone()) {
      var pt = plans.querySelector(".ioc-rail__track");
      var twelve = plans.querySelector("[data-plan-n='12']");
      var li = twelve && twelve.closest("li");
      if (pt && li) {
        var pad = parseFloat(getComputedStyle(pt).paddingLeft) || 0;
        pt.scrollTo({ left: Math.max(0, li.offsetLeft - pad), behavior: "instant" });
      }
    }

    // ---- tap-to-play video (reel): poster first, muted, plays only on a tap, pauses when scrolled away ----
    $$("[data-ioc-video-toggle]").forEach(function (btn) {
      var fig = btn.closest(".reel-vid");
      var v = fig && fig.querySelector("video[data-ioc-tap-video]");
      if (!v) return;
      v.muted = true;
      function set(playing) {
        fig.classList.toggle("is-playing", playing);
        // final-a: the name stays "Play the unboxing video"; aria-pressed carries the on/off state
        btn.setAttribute("aria-pressed", playing ? "true" : "false");
      }
      btn.addEventListener("click", function () {
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () { set(false); }); set(true); }
        else { v.pause(); set(false); }
      });
      v.addEventListener("pause", function () { set(false); });
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (en) { en.forEach(function (x) { if (!x.isIntersecting && !v.paused) v.pause(); }); }, { threshold: 0.2 }).observe(v);
      }
    });

    // duck picks: a random flavor card's native add-to-cart button. On the box builder (Run 5) ioc-shop.js owns the
    // button and fills the open slots itself; on box-model pages without a builder the cards are links to it, so
    // follow a random one (it pre-adds that flavor).
    document.querySelectorAll("[data-duck-picks]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (document.querySelector("[data-ioc-builder][data-mode='box']")) return;
        var btns = Array.prototype.slice.call(document.querySelectorAll("#iocFlavorGrid .flavor-card button[name='add']:not([disabled]), [data-ioc-grid] .flavor-card button[name='add']:not([disabled])"));
        if (btns.length) { btns[Math.floor(Math.random() * btns.length)].click(); return; }
        var links = Array.prototype.slice.call(document.querySelectorAll("#iocFlavorGrid .flavor-card a[data-ioc-add-to-box]"));
        if (links.length) window.location.href = links[Math.floor(Math.random() * links.length)].href;
      });
    });

    // scroll rails: the review rail, and (18 Sep) the craft carousel. Each button drives the rail inside
    // its own .rail-wrap, falling back to the review rail so nothing that already worked changes.
    var rail = document.getElementById("iocRail");
    document.querySelectorAll("[data-rail]").forEach(function (b) {
      b.addEventListener("click", function () {
        var dir = b.getAttribute("data-rail") === "next" ? 1 : -1;
        var wrap = b.closest(".rail-wrap");
        var r = (wrap && wrap.querySelector(".rail")) || rail;
        // final-a: no glide when the OS asks for reduced motion or the visitor paused motion
        var still = (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) || document.documentElement.classList.contains("ioc-motion-paused");
        if (r) r.scrollBy({ left: dir * Math.min(384, Math.round(r.clientWidth * 0.85)), behavior: still ? "auto" : "smooth" });
      });
    });

    // pause motion (WCAG 2.2.2): one control stops the ticker, the CSS animations and the autoplay
    // videos. Starts paused when the OS asks for reduced motion or the visitor paused it before.
    var rm = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
    var stored = null;
    try { stored = window.localStorage.getItem("ioc-motion"); } catch (e) {}
    function setMotion(paused, remember) {
      document.documentElement.classList.toggle("ioc-motion-paused", paused);
      document.querySelectorAll(".ioc video").forEach(function (v) {
        // tap-to-play videos never start on their own; ambient underlays only run at desktop widths
        if (v.hasAttribute("data-ioc-tap-video")) { if (paused) v.pause(); return; }
        if (v.hasAttribute("data-ioc-ambient") && isPhone()) { v.pause(); return; }
        if (paused) { v.pause(); v.removeAttribute("autoplay"); }
        else if (v.muted) { v.setAttribute("autoplay", ""); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
      document.querySelectorAll("[data-motion-toggle]").forEach(function (b) {
        // final-a: the name stays "Pause motion"; aria-pressed="true" says it is paused
        b.setAttribute("aria-pressed", paused ? "true" : "false");
      });
      if (remember) { try { window.localStorage.setItem("ioc-motion", paused ? "paused" : "playing"); } catch (e) {} }
    }
    setMotion(stored === "paused" || (stored !== "playing" && !!(rm && rm.matches)), false);
    if (rm && rm.addEventListener) rm.addEventListener("change", function (e) { if (stored === null) setMotion(e.matches, false); });
    document.querySelectorAll("[data-motion-toggle]").forEach(function (b) {
      b.addEventListener("click", function () {
        var paused = !document.documentElement.classList.contains("ioc-motion-paused");
        stored = paused ? "paused" : "playing";
        setMotion(paused, true);
      });
    });

    // B4 row 14 (SA sa-header port): account menu. Click or Enter opens, Escape and outside click close, focus
    // returns to the button, aria-expanded stays in sync, Up/Down roam the items.
    document.querySelectorAll("[data-ioc-acct]").forEach(function (a) {
      var b = a.querySelector("button[aria-controls]");
      var m = b && document.getElementById(b.getAttribute("aria-controls"));
      if (!b || !m) return;
      function items() { return Array.prototype.slice.call(m.querySelectorAll("[role='menuitem']")); }
      function setOpen(open, focusFirst) {
        m.hidden = !open;
        a.classList.toggle("open", open);
        b.setAttribute("aria-expanded", open ? "true" : "false");
        if (open && focusFirst) { var f = items()[0]; if (f) f.focus(); }
      }
      b.addEventListener("click", function (e) { e.stopPropagation(); setOpen(m.hidden, false); });
      b.addEventListener("keydown", function (e) {
        if (e.key === "ArrowDown" || (e.key === "Enter" && m.hidden) || (e.key === " " && m.hidden)) { e.preventDefault(); setOpen(true, true); }
      });
      m.addEventListener("keydown", function (e) {
        var list = items(), i = list.indexOf(document.activeElement);
        if (e.key === "ArrowDown") { e.preventDefault(); (list[(i + 1) % list.length] || list[0]).focus(); }
        else if (e.key === "ArrowUp") { e.preventDefault(); (list[(i - 1 + list.length) % list.length] || list[0]).focus(); }
        else if (e.key === "Home") { e.preventDefault(); list[0] && list[0].focus(); }
        else if (e.key === "End") { e.preventDefault(); list[list.length - 1] && list[list.length - 1].focus(); }
        else if (e.key === "Tab") { setOpen(false, false); }
      });
      a.addEventListener("keydown", function (e) { if (e.key === "Escape" && !m.hidden) { e.preventDefault(); setOpen(false, false); b.focus(); } });
      document.addEventListener("click", function (e) { if (!m.hidden && !a.contains(e.target)) setOpen(false, false); });
      a.addEventListener("focusout", function (e) { if (!m.hidden && e.relatedTarget && !a.contains(e.relatedTarget)) setOpen(false, false); });
    });

    // mobile menu: Escape closes the details sheet and returns focus to the burger (keyboard parity with the dialogs)
    var burger = document.querySelector(".ioc .nav-burger");
    if (burger) {
      burger.addEventListener("keydown", function (e) {
        if (e.key !== "Escape" || !burger.open) return;
        burger.open = false;
        var sum = burger.querySelector("summary");
        if (sum) sum.focus();
      });
    }

    // peek ducks: appear past one scroll point, hide again past another.
    // Observe the clip window (not the duck, which starts translated outside it).
    var targets = Array.prototype.slice.call(document.querySelectorAll(".ioc .peek-clip, .ioc .peek")).filter(function (el) {
      return !el.closest(".peek-clip") || el.classList.contains("peek-clip");
    });
    var duckOf = function (el) { return el.classList.contains("peek-clip") ? el.querySelector(".peek") : el; };
    if (targets.length && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var d = duckOf(en.target);
          if (d) d.classList.toggle("show", en.isIntersecting && en.intersectionRatio > 0.15);
        });
      }, { threshold: [0, 0.15, 0.6], rootMargin: "-8% 0px -12% 0px" });
      targets.forEach(function (t) { io.observe(t); });
    } else {
      targets.forEach(function (t) { var d = duckOf(t); if (d) d.classList.add("show"); });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
